module.exports = "img/flags/SM.895a723.png";